import type { PropType } from 'vue';
import {
    UPDATE_MODEL_VALUE,
    type ComponentSizes, componentSizeProp,
    type ComponentView, componentViewProp,
    type ClearableType, clearableProp,
} from '../../constants';

export interface InputNumberProps {
    modelValue: number | string,
    size?: ComponentSizes,
    readonly?: boolean,
    disabled?: boolean,
    loading?: boolean,
    min?: number,
    max?: number,
    placeholder?: string,
    clearable?: ClearableType,
    view?: ComponentView,
    textAlign?: 'start' | 'center' | 'end',
    precision?: number,
    thousands?: boolean,
}

export const inputNumberProps = {
    modelValue: {
        type: [Number, String] as PropType<InputNumberProps['modelValue']>,
        default: undefined,
        required: false,
    },
    size: componentSizeProp,
    readonly: {
        type: Boolean as PropType<InputNumberProps['readonly']>,
        default: undefined,
        required: false,
    },
    disabled: {
        type: Boolean as PropType<InputNumberProps['disabled']>,
        default: undefined,
        required: false,
    },
    loading: {
        type: Boolean as PropType<InputNumberProps['loading']>,
        default: undefined,
        required: false,
    },
    min: {
        type: Number as PropType<InputNumberProps['min']>,
        default: undefined,
        required: false,
    },
    max: {
        type: Number as PropType<InputNumberProps['max']>,
        default: undefined,
        required: false,
    },
    placeholder: {
        type: String as PropType<InputNumberProps['placeholder']>,
        default: undefined,
        required: false,
    },
    clearable: clearableProp,
    view: componentViewProp,
    textAlign: {
        type: String as PropType<InputNumberProps['textAlign']>,
        default: 'left',
        required: false,
    },
    precision: {
        type: Number as PropType<InputNumberProps['precision']>,
        default: undefined,
        required: false,
    },
    thousands: {
        type: Boolean as PropType<InputNumberProps['thousands']>,
        default: false,
        required: false,
    },
};

export const inputNumberEmits = {
    [UPDATE_MODEL_VALUE]: (event: number | string) => event,
};
